// UserInfo.tsx

import React, { FC } from 'react';
import cns from 'classnames';
import { ReactComponent as ProfileIcon } from 'icons/user_icon.svg';
import { ReactComponent as ProfileIconActive } from 'icons/user_icon_active.svg';
import styles from './UserInfo.module.scss';
import { useLocation } from 'react-router-dom';
import ROUTES from 'constants/routes';

interface Props {
  name: string;
  id: number;
  className?: string;
  active?: boolean; 
}

const UserInfo: FC<Props> = ({ name, id, className, active: propActive }) => {
  const location = useLocation();
  const isActive = propActive !== undefined ? propActive : location.pathname === ROUTES.HOME;

  return (
    <div className={cns(styles.wrapper, className)}>
      {isActive ? (
        <ProfileIconActive className={styles.avatar} />
      ) : (
        <ProfileIcon className={styles.avatar} />
      )}
      <div className={styles.text}>
        <div className={styles.name}>
          Здравствуйте{name && ','}
          {name && (
            <>
              <br />
              {name}
            </>
          )}
          !
        </div>
        <div className={styles.id}>Ваш ID: {id}</div>
      </div>
    </div>
  );
};

export default UserInfo;
